import { Stack, Typography } from "@mui/material";
import { PlaybookTitle } from "./PlaybookTitle";
import { H4Component } from "./H4Component";
import { TextBlock } from "./TextBlock";
import { CardWrapper } from "./CardWrapper";
import { OlList } from "./OlList";
import { FirstCallType } from "../../../../types";
import { NotRightBlock } from "./NotRightBlock";

const Title = ({
  title,
  color = "#024760",
}: {
  title: string;
  color?: string;
}) => (
  <Typography
    component="h5"
    sx={{
      color,
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "22px",
    }}
  >
    {title}
  </Typography>
);

export const FirstCallScriptBlock = ({
  call_goal,
  call_intro,
  call_contextual_hook,
  call_discovery_questions,
  call_value_alignment,
  call_close,
  topic,
}: FirstCallType & { topic: string }) => {
  return (
    <Stack gap={"20px"} id={topic}>
      <PlaybookTitle text={topic} />
      {call_goal && (
        <Stack gap={"8px"}>
          <H4Component text={"Call Goal"} />
          <TextBlock text={[call_goal]} />
        </Stack>
      )}

      {call_intro && (
        <CardWrapper isCard={true}>
          <Stack gap="20px">
            <Title title={"Intro (30–45 seconds)"} />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={call_intro.slice(0, -1)} />
            </Stack>
            <TextBlock
              text={[
                "*(Pause for confirmation — this confirms intent alignment.)*",
              ]}
            />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={call_intro.slice(-1)} />
            </Stack>
          </Stack>
        </CardWrapper>
      )}
      {call_contextual_hook && (
        <CardWrapper isCard={true}>
          <Stack gap="20px">
            <Title title={"Contextual Hook (30–45 seconds)"} />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={call_contextual_hook} />
            </Stack>
          </Stack>
        </CardWrapper>
      )}

      {call_discovery_questions && (
        <CardWrapper isCard={true}>
          <Stack gap="20px">
            <Stack flexDirection={"row"} gap="4px">
              <Title title={"Discovery Questions"} />
              <Title title={"(Choose 2–3 to Ask)"} color={"#9B9B9B"} />
            </Stack>
            <OlList text={call_discovery_questions} />
          </Stack>
        </CardWrapper>
      )}

      {call_value_alignment && (
        <CardWrapper isCard={true}>
          <Stack gap="20px">
            <Title
              title={
                "Value Alignment + Soft Pitch (30 seconds) - How Your Solution Addresses Their Goals"
              }
            />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={call_value_alignment} />
            </Stack>
          </Stack>
        </CardWrapper>
      )}

      {call_close && (
        <CardWrapper isCard={true}>
          <Stack gap="20px">
            <Title
              title={"Close — Offer Time Slots for an Intro Conversation"}
            />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={call_close} />
            </Stack>
            <TextBlock text={["*(Offer two time options.)*"]} />
          </Stack>
        </CardWrapper>
      )}

      <NotRightBlock />
    </Stack>
  );
};
